import { tns } from 'tiny-slider';

export function reviewSlider() {
    let slider = document.getElementById('review-slider');
    if (slider) {
        slider = tns({
            container: '#review-slider',
            items: 1.25,
            gutter: 24,
            autoplay: true,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<img src="/assets/images/ui/prev.svg" alt="Vorige slide" width="" height="" loading="lazy">', '<img src="/assets/images/ui/next.svg" alt="Volgende slide" width="" height="" loading="lazy">'],
            nav: true,
            navPosition: 'bottom',
            mouseDrag: true,
            autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                576: {
                    items: 2
                },
                768: {
                    items: 3
                }
            }
        });
    }
    return 'reviewSlider';
}

export function gallerijSlider() {
    let slider = document.getElementById('gallerij-slider');
    if (slider) {
        slider = tns({
            container: '#gallerij-slider',
            items: 1,
            gutter: 24,
            autoplay: true,
            center: true,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: true,
            navPosition: 'bottom',
            controlsPosition: 'bottom',
            controlsText: ['<img src="/assets/images/ui/prev.svg" alt="Vorige slide" width="" height="" loading="lazy">', '<img src="/assets/images/ui/next.svg" alt="Volgende slide" width="" height="" loading="lazy">'],
            nav: true,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                576: {
                    items: 2
                },
                768: {
                    items: 3
                },
                1024: {
                    items: 4
                },
                1366: {
                    items: 5,
                    nav: false
                },
                1600: {
                    items: 6
                }
            }
        });
    }
    return 'gallerijSlider';
}

export function dienstenSlider() {
    let slider = document.getElementById('diensten-slider');
    if (slider) {
        slider = tns({
            container: '#diensten-slider',
            items: 1,
            gutter: 0,
            autoplay: true,
            autoHeight: true,
            autoplayButton: false,
            autoplayButtonOutput: '',
            nav: true,
            navPosition: 'bottom',
            controls: true,
            controlsPosition: 'bottom',
            controlsText: ['<img src="/assets/images/ui/prev.svg" alt="Vorige slide" width="" height="" loading="lazy">', '<img src="/assets/images/ui/next.svg" alt="Volgende slide" width="" height="" loading="lazy">'],
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
        });
    }
    return 'dienstenSlider';
}